import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { MdOutlineCloudUpload } from 'react-icons/md'; // Cloud-Based Model Deployment
import { MdOutlineDevices } from 'react-icons/md'; 
import img1 from "../../../assets/img/EngineeringExcellence/ProductEngineering/5.jpeg"
import { RiExchangeLine } from 'react-icons/ri';
import { AiOutlineCloudServer, AiOutlineSafety, AiOutlineClockCircle, AiOutlineSync, AiOutlineStar } from 'react-icons/ai';
import { FiRefreshCcw } from 'react-icons/fi';



export default function MainSection6() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            DevSecOps for Secure and Reliable Products
            </h1>
            <p className="text-lg text-gray-600">
            Integrate Site Reliability Engineering (SRE) practices, we emphasize operational excellence, delivering robust, high-performing solutions that meet the highest industry standards.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineSafety className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Embedded Security Practices
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
              Security is integrated into every phase of the product development lifecycle to ensure compliance and robustness.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineSync className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">DevSecOps Integration</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Leveraging DevSecOps ensures seamless incorporation of security measures, creating reliable and secure products.
              </p>
            </div>
          {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineClockCircle className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Site Reliability Engineering (SRE)</h3>
              </div>
              <p className="text-gray-600 text-sm">
              SRE practices are applied to enhance availability, resilience, and performance of products.
              </p>
            </div>          
            {/* Feature 4 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineStar className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Commitment to Excellence
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
              By focusing on security and reliability, we consistently meet and exceed industry standards.
              </p>
            </div>
      
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}